import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bold" }, "Resumen", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "fs-base" }, "Resumen de tu cita", -1)
const _hoisted_3 = { class: "fs-2 fw-bold" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-sm-12 col-md-6 col-lg-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fs-base fw-bold mt-4 mb-4"
}, [
  /*#__PURE__*/_createTextVNode("Nombre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "isax-user text-white" }, null, -1)
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-6 col-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fs-base fw-bold mt-4 mb-4"
}, [
  /*#__PURE__*/_createTextVNode("Apellidos "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fs-base fw-bold mt-4 mb-4"
}, [
  /*#__PURE__*/_createTextVNode("Correo electrónico "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "isax-attach-circle text-white" }, null, -1)
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "fs-base fw-bold mt-4 mb-4"
}, [
  /*#__PURE__*/_createTextVNode("Teléfono "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "isax-call text-white" }, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = { class: "col-md-12 text-left mt-10" }
const _hoisted_20 = { class: "d-flex justify-content-left" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "float-start inline-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "40",
    src: "media/icons/iconsax/shop.svg",
    alt: "logo"
  })
], -1)
const _hoisted_22 = { class: "float-start" }
const _hoisted_23 = { class: "fs-base mb-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "fs-sm text-gray" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "fs-sm text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("h3", _hoisted_3, _toDisplayString($props.data.appointment.formatted_date), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_input, {
          class: "w-100 fs-base fw-bold",
          size: "large",
          clearable: "",
          placeholder: "Nombre",
          modelValue: $props.data.customer.Names,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.data.customer.Names) = $event)),
          disabled: true
        }, {
          prefix: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_input, {
          class: "w-100 fs-base",
          size: "large",
          clearable: "",
          placeholder: "Apellidos",
          modelValue: $props.data.customer.Surnames,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($props.data.customer.Surnames) = $event)),
          disabled: true
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_el_input, {
          class: "w-100 fs-base",
          size: "large",
          clearable: "",
          placeholder: "Correo electrónico",
          modelValue: $props.data.customer.Email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($props.data.customer.Email) = $event)),
          disabled: true
        }, {
          prefix: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_el_input, {
          class: "w-100 fs-base",
          size: "large",
          clearable: "",
          placeholder: "Teléfono",
          modelValue: $props.data.customer.Phone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($props.data.customer.Phone) = $event)),
          disabled: true
        }, {
          prefix: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    ($props.data.appointment.tipo == '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, [
                  _createTextVNode(_toDisplayString($props.data.agency.name), 1),
                  _hoisted_24,
                  _createElementVNode("span", _hoisted_25, _toDisplayString($props.data.agency.address) + ", " + _toDisplayString($props.data.agency.colonia), 1),
                  _createTextVNode(),
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, _toDisplayString($props.data.agency.city) + ", " + _toDisplayString($props.data.agency.state), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}